import { render, staticRenderFns } from "./giftBoxShare.vue?vue&type=template&id=4b64a9f6&scoped=true&"
import script from "./giftBoxShare.vue?vue&type=script&lang=js&"
export * from "./giftBoxShare.vue?vue&type=script&lang=js&"
import style0 from "./giftBoxShare.vue?vue&type=style&index=0&id=4b64a9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64a9f6",
  null
  
)

export default component.exports